import React, { useState } from 'react';
import { Box, Input, List, ListItem } from '@chakra-ui/react';

interface Option {
    label: string;
    value: string;
}

interface SearchableSelectProps {
    options: Option[];
    placeholder?: string;
    onSelect: (value: string) => void;
    value?: string;
}

export const SearchableSelect: React.FC<SearchableSelectProps> = ({
    options,
    placeholder = "Type to search",
    onSelect,
    value = ""
}) => {
    const [searchTerm, setSearchTerm] = useState<string>(value);
    const [showOptions, setShowOptions] = useState<boolean>(false);

    const filteredOptions = options.filter(option =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelect = (option: Option) => {
        setSearchTerm(option.label);
        setShowOptions(false);
        onSelect(option.value);
    };

    return (
        <Box position="relative" width="300px">
            <Input
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setShowOptions(true)}
                onBlur={() => setTimeout(() => setShowOptions(false), 200)}
            />
            {showOptions && filteredOptions.length > 0 && (
                <List
                    position="absolute"
                    top="100%"
                    left={0}
                    right={0}
                    bg="white"
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    maxH="200px"
                    overflowY="auto"
                    zIndex={10}
                >
                    {filteredOptions.map((option) => (
                        <ListItem
                            key={option.value}
                            p={2}
                            cursor="pointer"
                            _hover={{ bg: "gray.100" }}
                            onClick={() => handleSelect(option)}
                        >
                            {option.label}
                        </ListItem>
                    ))}
                </List>
            )}
        </Box>
    );
};

export default SearchableSelect;